import {
  addDeviceSpecsToApm,
  submitPageImpression,
  trackDevicePixelRatio,
  trackDevicePreferences,
  trackDeviceTextSize,
} from "./async/tracking.js";

import { defineStore } from "../nexus/defines.js";
import type { DevicePointerType } from ".";
import { o_global } from "../../common/namespaces";
import { assignNamespace } from "../../common/namespace-utils";
import { Hybrid, hybrid } from "./async/hybrid.js";
import { detectOrientation, Orientation } from "./async/orientation.js";
import { isTouchable } from "./async/touch.js";
import * as screen from "./async/screen.js";
import { browser, getPointerType, getScreenSpecs, os, type } from "./index.js";

/**
 *
 */
assignNamespace(
  o_global,
  "device",
  { os, browser, type },
  {
    Hybrid,
    Orientation,
    orientation: detectOrientation(),
    isTouchable: isTouchable(),
    hybrid: hybrid(),
    screen,
    breakpoint: o_global.breakpoint,
  },
);

otto.device.assignNamespace({
  pointerType: defineStore<DevicePointerType | undefined>({
    isTouchable: isTouchable(),
    isHybrid: hybrid().isHybrid,
  }),
  getPointerType,
  getScreenSpecs,
});

/*                             */
(async () => {
  trackDevicePreferences();
  trackDeviceTextSize();
  await trackDevicePixelRatio();
  submitPageImpression();
  addDeviceSpecsToApm();
})();
